import React, { useEffect, useState } from "react";
import { Route, Routes, Navigate, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import Login from "../Pages/auth/Login";
import ResetPassword from "../Pages/auth/ResetPassword";
import ChangePasswordPage from "../Pages/auth/ChangePassword";
import DefaultLayout from "../components/Navigationbar/DefaultLayout";

import { setNavigateFunction } from "../redux/services/axiosApi";
import { useUser, useUser1, useUser2 } from "../redux/services/authSlice";

import Loader from "../common/Loader";
import { ROUTES } from "../constant";
import { routePermissions } from "./routePermissions";

// IMPORT ALL PAGES (same as your file)
import DashboardPage from "../Pages/DashboardPage";
import Classes from "../Pages/Classes";
import AddClasses from "../Pages/Classes/AddClasses";
import EditClasses from "../Pages/Classes/EditClasses";
import ContestType from "../Pages/contest-type";
import Contest from "../Pages/contest";
import AddContest from "../Pages/contest/addContest";
import EditContest from "../Pages/contest/EditContest";
import Subject from "../Pages/subject";
import Student from "../Pages/student";
import Banner from "../Pages/Banner";
import PrivacyPolicy from "../Pages/Privacy-policy";
import IncomeExpense from "../Pages/Income-expense";
import KYC from "../Pages/KYC";
import TermsCondition from "../Pages/Terms-condition";
import Legality from "../Pages/Legality";
import AboutUs from "../Pages/About-Us";
import UserDetail from "../Pages/UserDetail";
import UserReport from "../Pages/Report/user-report";
import QuestionReport from "../Pages/Report/question-report";
import ResultReport from "../Pages/Report/result-report";
import UserEarning from "../Pages/Contest-earning/user-earning";
import SlotTimeEarning from "../Pages/Contest-earning/slot-time-earning";
import ContestwiseEarning from "../Pages/Contest-earning/contestwise-earning";
import SubjectEarning from "../Pages/Contest-earning/subject-earning";
import QuestionPanel from "../Pages/Question-panel";
import ClassesEarning from "../Pages/Contest-earning/classes-earning";
import AddStudent from "../Pages/UserDetail/AddStudent";
import EditStudent from "../Pages/student/Edit-student";
import CopyQuestions from "../Pages/copy-questions";
import Setting from "../Pages/Setting";
import MockTestDiscount from "../Pages/MockTestDiscount";
import FreeMockTest from "../Pages/FreeMockTest";
import Courses from "../Pages/Courses";
import AddCourse from "../Pages/Courses/Add-course";
import EditCourse from "../Pages/Courses/Edit-course";
import Withdrawal from "../Pages/Withdrawal";
import ExamType from "../Pages/Exam-type";
import Goal from "../Pages/Goal";
import RefundPolicy from "../Pages/Refund-policy";
import ContactUs from "../Pages/Contact-Us";
import Blog from "../Pages/Blog";
import AddBlog from "../Pages/Blog/AddBlog";
import EditBlog from "../Pages/Blog/EditBlog";
import AddContact from "../Pages/Contact-Us/AddContact";
import EditContact from "../Pages/Contact-Us/EditContact";
import TrustedBy from "../Pages/TrustedBy";
import AddTrustedBy from "../Pages/TrustedBy/AddTrustedBy";
import EditTrustedBy from "../Pages/TrustedBy/EditTrustedBy";
import FAQ from "../Pages/FAQ";
import FAQForm from "../Pages/FAQ/FAQForm";
import HowItWorks from "../Pages/How-It-Work";
import HowItWorkForm from "../Pages/How-It-Work/HowItWorkForm";
import Features from "../Pages/Features";
import FeatureForm from "../Pages/Features/FeatureForm";
import Interface from "../Pages/Interface";
import InterfaceForm from "../Pages/Interface/InterfaceForm";
import Module from "../Pages/Module";
import ModuleForm from "../Pages/Module/ModuleForm";
import Lectures from "../Pages/Course-Lectures";
import LecturesTable from "../Pages/Course-Lectures/LecturesTable";
import LectureForm from "../Pages/Course-Lectures/LectureForm";
import CoursePurchase from "../Pages/Course-Purchase";
import CoursePurchaseForm from "../Pages/Course-Purchase/CoursePurchaseEdit";
import Workshop from "../Pages/Workshop";
import WorkshopForm from "../Pages/Workshop/WorkshopForm";
import WorkshopRegister from "../Pages/WorkshopRegister.js";
import WorkshopRegisterForm from "../Pages/WorkshopRegister.js/WorkshopRegisterForm";
import WorkshopTestimonial from "../Pages/Workshop-Testimonials";
import WorkshopTestimonialForm from "../Pages/Workshop-Testimonials/WorkshopTestimonialForm";
import WorkshopLecture from "../Pages/Workshop-Lecture";
import WorkshopLectureForm from "../Pages/Workshop-Lecture/WorkshopLectureForm";
import Coupon from "../Pages/Coupon";
import CouponForm from "../Pages/Coupon/CouponForm";
import YoutubeVisuals from "../Pages/YoutubeVisuals";
import SocialMediaVisuals from "../Pages/SocialMediaVisuals";
import PaymentMessage from "../Pages/Payment-Message";
import UserAdminForm from "../Pages/User-Admin/User-AdminForm";
import UserAdmin from "../Pages/User-Admin";
import WorkshopRequest from "../Pages/Withdrawal-Request/index.js";
import Leaderboard from "../Pages/contest/leaderboard.js";

// ==============================
// Authenticated Route Wrapper
// ==============================
const AuthenticatedRoute = ({ element, accessValue }) => {
  const { user1 } = useUser1();
  const { user } = useUser();
  const { user2 } = useUser2();

  const isAuthenticated =
    (user && Object.keys(user).length > 0 && user1 && Object.keys(user1).length > 0) ||
    (user2 && Object.keys(user2).length > 0 && user1 && Object.keys(user1).length > 0);

  if (!isAuthenticated) return <Navigate to="/login" replace />;

  // Admin always allowed
  if (user?.userType === "admin") return element;

  // 🔥 THIS IS THE IMPORTANT PART
  if (accessValue && !user1?.access?.includes(accessValue)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return element;
};


// ==============================
// Component Mapping
// ==============================
const routeComponentMap = {
  [ROUTES.HOME]: DashboardPage,
  [ROUTES.CLASSES.BASE]: Classes,
  [ROUTES.CLASSES.ADD]: AddClasses,
  [ROUTES.CLASSES.EDIT]: EditClasses,
  [ROUTES.QUESTIONS.BASE]: QuestionPanel,
  [ROUTES.QUESTIONS.COPY]: CopyQuestions,
  [ROUTES.QUESTIONS.SUBJECT]: Subject,
  [ROUTES.COURSES.BASE]: Courses,
  [ROUTES.COURSES.ADD]: AddCourse,
  [ROUTES.COURSES.EDIT]: EditCourse,
  [ROUTES.COURSES.MODULE]: Module,
  [ROUTES.COURSES.MODULE_ADD_EDIT]: ModuleForm,
  [ROUTES.COURSES.LECTURES]: Lectures,
  [ROUTES.COURSES.LECTURES_MODULE]: LecturesTable,
  [ROUTES.COURSES.LECTURES_MODULE_ADD_EDIT]: LectureForm,
  [ROUTES.COURSES.PURCHASE]: CoursePurchase,
  [ROUTES.COURSES.PURCHASE_EDIT]: CoursePurchaseForm,
  [ROUTES.COURSES.FAQ]: FAQ,
  [ROUTES.COURSES.FAQ_ADD_EDIT]: FAQForm,
  [ROUTES.WORKSHOPS.BASE]: Workshop,
  [ROUTES.WORKSHOPS.WORKSHOP_ADD_EDIT]: WorkshopForm,
  [ROUTES.WORKSHOPS.REGISTER]: WorkshopRegister,
  [ROUTES.WORKSHOPS.REGISTER_EDIT]: WorkshopRegisterForm,
  [ROUTES.WORKSHOPS.LECTURES]: WorkshopLecture,
  [ROUTES.WORKSHOPS.LECTURES_ADD_EDIT]: WorkshopLectureForm,
  [ROUTES.WORKSHOPS.TESTIMONIALS]: WorkshopTestimonial,
  [ROUTES.WORKSHOPS.TESTIMONIALS_ADD_EDIT]: WorkshopTestimonialForm,
  [ROUTES.WORKSHOPS.FAQ]: FAQ,
  [ROUTES.WORKSHOPS.FAQ_ADD_EDIT]: FAQForm,
  [ROUTES.CONTEST.BASE]: Contest,
  [ROUTES.CONTEST.ADD]: AddContest,
  [ROUTES.CONTEST.EDIT]: EditContest,
  [ROUTES.CONTEST.TYPE]: ContestType,
  [ROUTES.CONTEST.LEADERBOARD]: Leaderboard,
  [ROUTES.REPORTS.USER]: UserReport,
  [ROUTES.REPORTS.QUESTION]: QuestionReport,
  [ROUTES.REPORTS.RESULT]: ResultReport,
  [ROUTES.EARNINGS.CONTEST_WISE]: ContestwiseEarning,
  [ROUTES.EARNINGS.SUBJECT_WISE]: SubjectEarning,
  [ROUTES.EARNINGS.SLOT_TIME]: SlotTimeEarning,
  [ROUTES.EARNINGS.USER]: UserEarning,
  [ROUTES.EARNINGS.CLASSES]: ClassesEarning,
  [ROUTES.USERS.BASE]: Student,
  [ROUTES.USERS.DETAIL]: UserDetail,
  [ROUTES.USERS.ADD]: AddStudent,
  [ROUTES.USERS.EDIT]: EditStudent,
  [ROUTES.USERS.KYC]: KYC,
  [ROUTES.WEBSITE.INTERFACE]: Interface,
  [ROUTES.WEBSITE.INTERFACE_ADD_EDIT]: InterfaceForm,
  [ROUTES.WEBSITE.FEATURES]: Features,
  [ROUTES.WEBSITE.FEATURES_ADD_EDIT]: FeatureForm,
  [ROUTES.WEBSITE.HOW_IT_WORKS]: HowItWorks,
  [ROUTES.WEBSITE.HOW_IT_WORKS_ADD_EDIT]: HowItWorkForm,
  [ROUTES.WEBSITE.FAQ]: FAQ,
  [ROUTES.WEBSITE.FAQ_ADD_EDIT]: FAQForm,
  [ROUTES.WEBSITE.TRUSTED_BY]: TrustedBy,
  [ROUTES.WEBSITE.TRUSTED_BY_ADD]: AddTrustedBy,
  [ROUTES.WEBSITE.TRUSTED_BY_EDIT]: EditTrustedBy,
  [ROUTES.WEBSITE.BANNER]: Banner,
  [ROUTES.WEBSITE.BLOG]: Blog,
  [ROUTES.WEBSITE.BLOG_ADD]: AddBlog,
  [ROUTES.WEBSITE.BLOG_EDIT]: EditBlog,
  [ROUTES.WEBSITE.CONTACT_ENQUIRIES]: ContactUs,
  [ROUTES.WEBSITE.CONTACT_ENQUIRIES_ADD]: AddContact,
  [ROUTES.WEBSITE.CONTACT_ENQUIRIES_EDIT]: EditContact,
  [ROUTES.WEBSITE.ABOUT_US]: AboutUs,
  [ROUTES.WEBSITE.PRIVACY_POLICY]: PrivacyPolicy,
  [ROUTES.WEBSITE.TERMS_CONDITION]: TermsCondition,
  [ROUTES.WEBSITE.LEGALITY]: Legality,
  [ROUTES.FINANCE.INCOME_EXPENSE]: IncomeExpense,
  [ROUTES.FINANCE.WITHDRAWAL]: Withdrawal,
  [ROUTES.FINANCE.WITHDRAWAL_REQUEST]: WorkshopRequest,
  [ROUTES.FINANCE.REFUND_POLICY]: RefundPolicy,
  [ROUTES.COUPON.BASE]: Coupon,
  [ROUTES.COUPON.ADD_EDIT]: CouponForm,
  [ROUTES.SETTINGS]: Setting,
  [ROUTES.MOCK_TEST_DISCOUNT]: MockTestDiscount,
  [ROUTES.FREE_MOCK_TEST]: FreeMockTest,
  [ROUTES.PAYMENT_MESSAGE]: PaymentMessage,

  [ROUTES.EXAM_TYPE]: ExamType,
  [ROUTES.GOAL]: Goal,
  [ROUTES.YOUTUBE_VISUALS]: YoutubeVisuals,
  [ROUTES.SOCIAL_MEDIA_ENGAGE]: SocialMediaVisuals,
  [ROUTES.USER_ADMIN.BASE]: UserAdmin,
  [ROUTES.USER_ADMIN.ADD_EDIT]: UserAdminForm,
};

const getComponentForRoute = (path) => routeComponentMap[path];

// ==============================
// MAIN ROUTE TREE
// ==============================
const Allroutes = () => {
  const { user1 } = useUser1();
  const { user } = useUser();
  const { user2 } = useUser2();
  const isAuthenticate = (user && Object.keys(user).length > 0 && user1 && Object.keys(user1).length > 0) || (user2 && Object.keys(user2).length > 0 && user1 && Object.keys(user1).length > 0);

  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    setNavigateFunction(navigate, dispatch);
    setTimeout(() => setLoading(false), 400);
  }, [dispatch, navigate]);

  if (loading)
    return (
      <div className="h-screen">
        <Loader />
      </div>
    );

  return (
    <React.Suspense fallback={""}>
      <Routes>
        {/* AUTH ROUTES */}
        <Route path={ROUTES.LOGIN} element={isAuthenticate ? <Navigate to={ROUTES.HOME} /> : <Login />} />
        <Route path={ROUTES.RESET_PASSWORD} element={isAuthenticate ? <Navigate to={ROUTES.HOME} /> : <ResetPassword />} />
        <Route path={ROUTES.CHANGE_PASSWORD} element={<AuthenticatedRoute element={<ChangePasswordPage />} />} />

        {/* PROTECTED ROUTES */}
        <Route path="" element={<AuthenticatedRoute element={<DefaultLayout />} />}>
          {routePermissions.map((rp) => {
            const Component = getComponentForRoute(rp.path);
            return <Route key={rp.path} path={rp.path} element={<AuthenticatedRoute element={<Component />} accessValue={rp.value} />} />;
          })}
        </Route>

        {/* CATCH ALL */}
        <Route path="*" element={<Navigate to={ROUTES.LOGIN} />} />
      </Routes>
    </React.Suspense>
  );
};

export default Allroutes;

// import React, { useEffect, useState } from "react";
// import { Route, Routes, Navigate, useNavigate } from "react-router-dom";
// import Login from "../Pages/auth/Login";
// import { useUser, useUser1, useUser2 } from "../redux/services/authSlice";
// import Classes from "../Pages/Classes";
// import AddClasses from "../Pages/Classes/AddClasses";
// import EditClasses from "../Pages/Classes/EditClasses";
// import ContestType from "../Pages/contest-type";
// import Contest from "../Pages/contest";
// import AddContest from "../Pages/contest/addContest";
// import EditContest from "../Pages/contest/EditContest";
// import Subject from "../Pages/subject";
// import Student from "../Pages/student";
// import Banner from "../Pages/Banner";
// import PrivacyPolicy from "../Pages/Privacy-policy";
// import Loader from "../common/Loader";
// import IncomeExpense from "../Pages/Income-expense";
// import KYC from "../Pages/KYC";
// import TermsCondition from "../Pages/Terms-condition";
// import Legality from "../Pages/Legality";
// import AboutUs from "../Pages/About-Us";
// import { setNavigateFunction } from "../redux/services/axiosApi";
// import { useDispatch } from "react-redux";
// import ResetPassword from "../Pages/auth/ResetPassword";
// import ChangePasswordPage from "../Pages/auth/ChangePassword";
// import UserDetail from "../Pages/UserDetail";
// import DefaultLayout from "../components/Navigationbar/DefaultLayout";
// import UserReport from "../Pages/Report/user-report";
// import QuestionReport from "../Pages/Report/question-report";
// import ResultReport from "../Pages/Report/result-report";
// import UserEarning from "../Pages/Contest-earning/user-earning";
// import SlotTimeEarning from "../Pages/Contest-earning/slot-time-earning";
// import ContestwiseEarning from "../Pages/Contest-earning/contestwise-earning";
// import SubjectEarning from "../Pages/Contest-earning/subject-earning";
// import QuestionPanel from "../Pages/Question-panel";
// import ClassesEarning from "../Pages/Contest-earning/classes-earning";
// import AddStudent from "../Pages/UserDetail/AddStudent";
// import EditStudent from "../Pages/student/Edit-student";
// import CopyQuestions from "../Pages/copy-questions";
// import Setting from "../Pages/Setting";
// import Courses from "../Pages/Courses";
// import AddCourse from "../Pages/Courses/Add-course";
// import EditCourse from "../Pages/Courses/Edit-course";
// import Withdrawal from "../Pages/Withdrawal";
// import ExamType from "../Pages/Exam-type";
// import Goal from "../Pages/Goal";
// import { ROUTES } from "../constant";
// import DashboardPage from "../Pages/DashboardPage";
// import RefundPolicy from "../Pages/Refund-policy";
// import ContactUs from "../Pages/Contact-Us";
// import Blog from "../Pages/Blog";
// import AddBlog from "../Pages/Blog/AddBlog";
// import EditBlog from "../Pages/Blog/EditBlog";
// import AddContact from "../Pages/Contact-Us/AddContact";
// import EditContact from "../Pages/Contact-Us/EditContact";
// import TrustedBy from "../Pages/TrustedBy";
// import AddTrustedBy from "../Pages/TrustedBy/AddTrustedBy";
// import EditTrustedBy from "../Pages/TrustedBy/EditTrustedBy";
// import FAQ from "../Pages/FAQ";
// import FAQForm from "../Pages/FAQ/FAQForm";
// import HowItWorks from "../Pages/How-It-Work";
// import HowItWorkForm from "../Pages/How-It-Work/HowItWorkForm";
// import Features from "../Pages/Features";
// import FeatureForm from "../Pages/Features/FeatureForm";
// import Interface from "../Pages/Interface";
// import InterfaceForm from "../Pages/Interface/InterfaceForm";
// import Module from "../Pages/Module";
// import ModuleForm from "../Pages/Module/ModuleForm";
// import Lectures from "../Pages/Course-Lectures/index.js";
// import LecturesTable from "../Pages/Course-Lectures/LecturesTable.js";
// import LectureForm from "../Pages/Course-Lectures/LectureForm.js";
// import CoursePurchase from "../Pages/Course-Purchase";
// import CoursePurchaseForm from "../Pages/Course-Purchase/CoursePurchaseEdit";
// import Workshop from "../Pages/Workshop";
// import WorkshopForm from "../Pages/Workshop/WorkshopForm";
// import WorkshopRegister from "../Pages/WorkshopRegister.js";
// import WorkshopRegisterForm from "../Pages/WorkshopRegister.js/WorkshopRegisterForm";
// import WorkshopTestimonial from "../Pages/Workshop-Testimonials/index.js";
// import WorkshopTestimonialForm from "../Pages/Workshop-Testimonials/WorkshopTestimonialForm.js";
// import WorkshopLecture from "../Pages/Workshop-Lecture/index.js";
// import WorkshopLectureForm from "../Pages/Workshop-Lecture/WorkshopLectureForm.js";
// import Coupon from "../Pages/Coupon/index.js";
// import CouponForm from "../Pages/Coupon/CouponForm.js";
// import YoutubeVisuals from "../Pages/YoutubeVisuals/index.js";
// import SocialMediaVisuals from "../Pages/SocialMediaVisuals/index.js";
// import PaymentMessage from "../Pages/Payment-Message/index.js";
// import UserAdminForm from "../Pages/User-Admin/User-AdminForm.js";
// import UserAdmin from "../Pages/User-Admin/index.js";

// const AuthenticatedRoute = ({ component: Component }) => {
//   const { user1 } = useUser1();
//   const { user } = useUser();
//   const { user2 } = useUser2();

//   const isAuthenticated = (user && Object.keys(user).length > 0 && user1 && Object.keys(user1).length > 0) || (user2 && Object.keys(user2).length > 0 && user1 && Object.keys(user1).length > 0);

//   if (!isAuthenticated) {
//     return <Navigate to="/login" replace />;
//   }

//   return <Component />;
// };
// const Allroutes = () => {
//   const { user1 } = useUser1();
//   const { user } = useUser();
//   const { user2 } = useUser2();
//   const isAuthenticate = (user && Object.keys(user).length > 0 && user1 && Object.keys(user1).length > 0) || (user2 && Object.keys(user2).length > 0 && user1 && Object.keys(user1).length > 0);

//   const [loading, setLoading] = useState(true);
//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   useEffect(() => {
//     setNavigateFunction(navigate, dispatch);

//     const checkAuth = () => {
//       setLoading(false);
//     };
//     setTimeout(checkAuth, 500);
//   }, [navigate, dispatch]);

//   if (loading) {
//     return (
//       <div className="h-screen">
//         <Loader />
//       </div>
//     );
//   }
//   return (

//     <React.Suspense fallback={""}>
//       <Routes>
//         {/* Auth Routes */}
//         <Route path={ROUTES.LOGIN} element={isAuthenticate ? <Navigate to={ROUTES.HOME} replace /> : <Login />} />
//         <Route path={ROUTES.RESET_PASSWORD} element={isAuthenticate ? <Navigate to={ROUTES.HOME} replace /> : <ResetPassword />} />
//         <Route path={ROUTES.CHANGE_PASSWORD} element={<AuthenticatedRoute component={ChangePasswordPage} />} />
//         {/* Protected Routes */}
//         <Route path="" element={<AuthenticatedRoute component={DefaultLayout} />}>
//           {/* Dashboard */}
//           <Route path={ROUTES.HOME} element={<AuthenticatedRoute component={DashboardPage} />} />

//           {/* Classes */}
//           <Route path={ROUTES.CLASSES.BASE} element={<AuthenticatedRoute component={Classes} />} />
//           <Route path={ROUTES.CLASSES.ADD} element={<AuthenticatedRoute component={AddClasses} />} />
//           <Route path={ROUTES.CLASSES.EDIT} element={<AuthenticatedRoute component={EditClasses} />} />

//           {/* Questions */}
//           <Route path={ROUTES.QUESTIONS.BASE} element={<AuthenticatedRoute component={QuestionPanel} />} />
//           <Route path={ROUTES.QUESTIONS.COPY} element={<AuthenticatedRoute component={CopyQuestions} />} />
//           <Route path={ROUTES.QUESTIONS.SUBJECT} element={<AuthenticatedRoute component={Subject} />} />

//           {/* Courses */}
//           <Route path={ROUTES.COURSES.BASE} element={<AuthenticatedRoute component={Courses} />} />
//           <Route path={ROUTES.COURSES.ADD} element={<AuthenticatedRoute component={AddCourse} />} />
//           <Route path={ROUTES.COURSES.EDIT} element={<AuthenticatedRoute component={EditCourse} />} />
//           <Route path={ROUTES.COURSES.MODULE} element={<AuthenticatedRoute component={Module} />} />
//           <Route path={ROUTES.COURSES.MODULE_ADD_EDIT} element={<AuthenticatedRoute component={ModuleForm} />} />
//           <Route path={ROUTES.COURSES.LECTURES} element={<AuthenticatedRoute component={Lectures} />} />
//           <Route path={ROUTES.COURSES.LECTURES_MODULE} element={<AuthenticatedRoute component={LecturesTable} />} />
//           <Route path={ROUTES.COURSES.LECTURES_MODULE_ADD_EDIT} element={<AuthenticatedRoute component={LectureForm} />} />
//           <Route path={ROUTES.COURSES.PURCHASE} element={<AuthenticatedRoute component={CoursePurchase} />} />
//           <Route path={ROUTES.COURSES.PURCHASE_EDIT} element={<AuthenticatedRoute component={CoursePurchaseForm} />} />
//           <Route path={ROUTES.COURSES.FAQ} element={<AuthenticatedRoute component={FAQ} />} />
//           <Route path={ROUTES.COURSES.FAQ_ADD_EDIT} element={<AuthenticatedRoute component={FAQForm} />} />

//           {/* Workshops */}
//           <Route path={ROUTES.WORKSHOPS.BASE} element={<AuthenticatedRoute component={Workshop} />} />
//           <Route path={ROUTES.WORKSHOPS.WORKSHOP_ADD_EDIT} element={<AuthenticatedRoute component={WorkshopForm} />} />

//           <Route path={ROUTES.WORKSHOPS.REGISTER} element={<AuthenticatedRoute component={WorkshopRegister} />} />
//           <Route path={ROUTES.WORKSHOPS.REGISTER_EDIT} element={<AuthenticatedRoute component={WorkshopRegisterForm} />} />

//           <Route path={ROUTES.WORKSHOPS.LECTURES} element={<AuthenticatedRoute component={WorkshopLecture} />} />
//           <Route path={ROUTES.WORKSHOPS.LECTURES_ADD_EDIT} element={<AuthenticatedRoute component={WorkshopLectureForm} />} />
//           <Route path={ROUTES.WORKSHOPS.TESTIMONIALS} element={<AuthenticatedRoute component={WorkshopTestimonial} />} />
//           <Route path={ROUTES.WORKSHOPS.TESTIMONIALS_ADD_EDIT} element={<AuthenticatedRoute component={WorkshopTestimonialForm} />} />

//           <Route path={ROUTES.WORKSHOPS.FAQ} element={<AuthenticatedRoute component={FAQ} />} />
//           <Route path={ROUTES.WORKSHOPS.FAQ_ADD_EDIT} element={<AuthenticatedRoute component={FAQForm} />} />

//           {/* Contest */}
//           <Route path={ROUTES.CONTEST.BASE} element={<AuthenticatedRoute component={Contest} />} />
//           <Route path={ROUTES.CONTEST.ADD} element={<AuthenticatedRoute component={AddContest} />} />
//           <Route path={ROUTES.CONTEST.EDIT} element={<AuthenticatedRoute component={EditContest} />} />
//           <Route path={ROUTES.CONTEST.TYPE} element={<AuthenticatedRoute component={ContestType} />} />

//           {/* Reports */}
//           <Route path={ROUTES.REPORTS.USER} element={<AuthenticatedRoute component={UserReport} />} />
//           <Route path={ROUTES.REPORTS.QUESTION} element={<AuthenticatedRoute component={QuestionReport} />} />
//           <Route path={ROUTES.REPORTS.RESULT} element={<AuthenticatedRoute component={ResultReport} />} />

//           {/* Earnings */}
//           <Route path={ROUTES.EARNINGS.CONTEST_WISE} element={<AuthenticatedRoute component={ContestwiseEarning} />} />
//           <Route path={ROUTES.EARNINGS.SUBJECT_WISE} element={<AuthenticatedRoute component={SubjectEarning} />} />
//           <Route path={ROUTES.EARNINGS.SLOT_TIME} element={<AuthenticatedRoute component={SlotTimeEarning} />} />
//           <Route path={ROUTES.EARNINGS.USER} element={<AuthenticatedRoute component={UserEarning} />} />
//           <Route path={ROUTES.EARNINGS.CLASSES} element={<AuthenticatedRoute component={ClassesEarning} />} />

//           {/* Users */}
//           <Route path={ROUTES.USERS.BASE} element={<AuthenticatedRoute component={Student} />} />
//           <Route path={ROUTES.USERS.DETAIL} element={<AuthenticatedRoute component={UserDetail} />} />
//           <Route path={ROUTES.USERS.ADD} element={<AuthenticatedRoute component={AddStudent} />} />
//           <Route path={ROUTES.USERS.EDIT} element={<AuthenticatedRoute component={EditStudent} />} />
//           <Route path={ROUTES.USERS.KYC} element={<AuthenticatedRoute component={KYC} />} />

//           {/* Website Pages */}
//           <Route path={ROUTES.WEBSITE.INTERFACE} element={<AuthenticatedRoute component={Interface} />} />
//           <Route path={ROUTES.WEBSITE.INTERFACE_ADD_EDIT} element={<AuthenticatedRoute component={InterfaceForm} />} />

//           <Route path={ROUTES.WEBSITE.FEATURES} element={<AuthenticatedRoute component={Features} />} />
//           <Route path={ROUTES.WEBSITE.FEATURES_ADD_EDIT} element={<AuthenticatedRoute component={FeatureForm} />} />

//           <Route path={ROUTES.WEBSITE.HOW_IT_WORKS} element={<AuthenticatedRoute component={HowItWorks} />} />
//           <Route path={ROUTES.WEBSITE.HOW_IT_WORKS_ADD_EDIT} element={<AuthenticatedRoute component={HowItWorkForm} />} />

//           <Route path={ROUTES.WEBSITE.FAQ} element={<AuthenticatedRoute component={FAQ} />} />
//           <Route path={ROUTES.WEBSITE.FAQ_ADD_EDIT} element={<AuthenticatedRoute component={FAQForm} />} />

//           <Route path={ROUTES.WEBSITE.TRUSTED_BY} element={<AuthenticatedRoute component={TrustedBy} />} />
//           <Route path={ROUTES.WEBSITE.TRUSTED_BY_ADD} element={<AuthenticatedRoute component={AddTrustedBy} />} />
//           <Route path={ROUTES.WEBSITE.TRUSTED_BY_EDIT} element={<AuthenticatedRoute component={EditTrustedBy} />} />

//           <Route path={ROUTES.WEBSITE.BANNER} element={<AuthenticatedRoute component={Banner} />} />

//           <Route path={ROUTES.WEBSITE.BLOG} element={<AuthenticatedRoute component={Blog} />} />
//           <Route path={ROUTES.WEBSITE.BLOG_ADD} element={<AuthenticatedRoute component={AddBlog} />} />
//           <Route path={ROUTES.WEBSITE.BLOG_EDIT} element={<AuthenticatedRoute component={EditBlog} />} />

//           <Route path={ROUTES.WEBSITE.CONTACT_ENQUIRIES} element={<AuthenticatedRoute component={ContactUs} />} />
//           <Route path={ROUTES.WEBSITE.CONTACT_ENQUIRIES_ADD} element={<AuthenticatedRoute component={AddContact} />} />
//           <Route path={ROUTES.WEBSITE.CONTACT_ENQUIRIES_EDIT} element={<AuthenticatedRoute component={EditContact} />} />

//           <Route path={ROUTES.WEBSITE.ABOUT_US} element={<AuthenticatedRoute component={AboutUs} />} />
//           <Route path={ROUTES.WEBSITE.PRIVACY_POLICY} element={<AuthenticatedRoute component={PrivacyPolicy} />} />
//           <Route path={ROUTES.WEBSITE.TERMS_CONDITION} element={<AuthenticatedRoute component={TermsCondition} />} />
//           <Route path={ROUTES.WEBSITE.LEGALITY} element={<AuthenticatedRoute component={Legality} />} />

//           {/* Finance */}
//           <Route path={ROUTES.FINANCE.INCOME_EXPENSE} element={<AuthenticatedRoute component={IncomeExpense} />} />
//           <Route path={ROUTES.FINANCE.WITHDRAWAL} element={<AuthenticatedRoute component={Withdrawal} />} />
//           <Route path={ROUTES.FINANCE.REFUND_POLICY} element={<AuthenticatedRoute component={RefundPolicy} />} />

//           {/* Settings */}
//           <Route path={ROUTES.COUPON.BASE} element={<AuthenticatedRoute component={Coupon} />} />
//           <Route path={ROUTES.COUPON.ADD_EDIT} element={<AuthenticatedRoute component={CouponForm} />} />

//           {/* Settings */}
//           <Route path={ROUTES.SETTINGS} element={<AuthenticatedRoute component={Setting} />} />
//           <Route path={ROUTES.PAYMENT_MESSAGE} element={<AuthenticatedRoute component={PaymentMessage} />} />

//           {/* Others */}
//           <Route path={ROUTES.EXAM_TYPE} element={<AuthenticatedRoute component={ExamType} />} />
//           <Route path={ROUTES.GOAL} element={<AuthenticatedRoute component={Goal} />} />

//           {/* Youtube */}
//           <Route path={ROUTES.YOUTUBE_VISUALS} element={<AuthenticatedRoute component={YoutubeVisuals} />} />

//           {/* Social Media Visuals */}
//           <Route path={ROUTES.SOCIAL_MEDIA_ENGAGE} element={<AuthenticatedRoute component={SocialMediaVisuals} />} />
//           {/* Social Media Visuals */}
//           <Route path={ROUTES.USER_ADMIN.BASE} element={<AuthenticatedRoute component={UserAdmin} />} />
//           <Route path={ROUTES.USER_ADMIN.ADD_EDIT} element={<AuthenticatedRoute component={UserAdminForm} />} />

//         </Route>
//         {/* Catch-all */}
//         <Route path="*" element={<Navigate to={ROUTES.LOGIN} replace />} />
//       </Routes>
//     </React.Suspense>
//   );
// };

// export default Allroutes;
